export default function({ dispatch, commit }, params) {
    commit('startedAuthentication')

    // POST /auth/add/phone
    return dispatch('post', {
        url: '/auth/add/phone',
        data: params
    }, {
        root: true
    })
    .then((response) => {
        commit('finishedAuthentication')
        return response
    })
    .catch((error) => {
        commit('finishedAuthentication')
        return error
    })
}
